const ContentWrapperStyles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    clear: "both",
  },
});

export default ContentWrapperStyles;
